import { z } from 'zod';
import { permissionSchema } from './permission';
import { organizationSchema } from './organization';

export const roleSchema = z.object({
  id: z.string(),
  name: z.string(),
  organizationID: z.string().optional().nullable(),
  organization: z
    .lazy(() => organizationSchema)
    .optional()
    .nullable(),
  permissions: z.lazy(() => permissionSchema.array()),
});
